import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {createRequestFunction, DUMMY_BASE_URL, setSearchParams, toPathString} from '../common';
import {S3GetRsp, TemporarySignUrlRsp} from '../types/s3';

/**
 * S3ServiceApi - axios parameter creator
 * @export
 */
export const S3ServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 获取s3文件对象
     * @summary 获取s3文件对象
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    s3ServiceFileObject: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/s3/object/**`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 获取s3文件签名
     * @summary 获取s3文件签名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    s3ServiceGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/s3/sign_url/**`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 创建临时签名 url   用来上传临时的图片和文件, 24小时后过期
     * @summary 创建临时签名 url   用来上传临时的图片和文件, 24小时后过期
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    s3ServiceTemporarySignUrl: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/s3/create_obj_sign_url/**`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * S3ServiceApi - functional programming interface
 * @export
 */
export const S3ServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = S3ServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 获取s3文件对象
     * @summary 获取s3文件对象
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async s3ServiceFileObject(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.s3ServiceFileObject(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['S3ServiceApi.s3ServiceFileObject']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 获取s3文件签名
     * @summary 获取s3文件签名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async s3ServiceGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3GetRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.s3ServiceGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['S3ServiceApi.s3ServiceGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 创建临时签名 url   用来上传临时的图片和文件, 24小时后过期
     * @summary 创建临时签名 url   用来上传临时的图片和文件, 24小时后过期
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async s3ServiceTemporarySignUrl(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemporarySignUrlRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.s3ServiceTemporarySignUrl(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['S3ServiceApi.s3ServiceTemporarySignUrl']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * S3ServiceApi - factory interface
 * @export
 */
export const S3ServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = S3ServiceApiFp(configuration);
  return {
    /**
     * 获取s3文件对象
     * @summary 获取s3文件对象
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    s3ServiceFileObject(options?: any): AxiosPromise<void> {
      return localVarFp.s3ServiceFileObject(options).then(request => request(axios, basePath));
    },
    /**
     * 获取s3文件签名
     * @summary 获取s3文件签名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    s3ServiceGet(options?: any): AxiosPromise<S3GetRsp> {
      return localVarFp.s3ServiceGet(options).then(request => request(axios, basePath));
    },
    /**
     * 创建临时签名 url   用来上传临时的图片和文件, 24小时后过期
     * @summary 创建临时签名 url   用来上传临时的图片和文件, 24小时后过期
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    s3ServiceTemporarySignUrl(options?: any): AxiosPromise<TemporarySignUrlRsp> {
      return localVarFp
        .s3ServiceTemporarySignUrl(options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * S3ServiceApi - object-oriented interface
 * @export
 * @class S3ServiceApi
 * @extends {BaseAPI}
 */
export class S3ServiceApi extends BaseAPI {
  /**
   * 获取s3文件对象
   * @summary 获取s3文件对象
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof S3ServiceApi
   */
  public s3ServiceFileObject(options?: RawAxiosRequestConfig) {
    return S3ServiceApiFp(this.configuration)
      .s3ServiceFileObject(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 获取s3文件签名
   * @summary 获取s3文件签名
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof S3ServiceApi
   */
  public s3ServiceGet(options?: RawAxiosRequestConfig) {
    return S3ServiceApiFp(this.configuration)
      .s3ServiceGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 创建临时签名 url   用来上传临时的图片和文件, 24小时后过期
   * @summary 创建临时签名 url   用来上传临时的图片和文件, 24小时后过期
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof S3ServiceApi
   */
  public s3ServiceTemporarySignUrl(options?: RawAxiosRequestConfig) {
    return S3ServiceApiFp(this.configuration)
      .s3ServiceTemporarySignUrl(options)
      .then(request => request(this.axios, this.basePath));
  }
}
